import BaseView from '../../core/baseView';
import { updateState } from '../../../home24/helpers/custom-elements';

export default BaseView.extend({

    events: {
        'change [name="payment[method]"]': 'onUserPaymentMethodChange'
    },

    selectors: {
        content: '.checkout-frame',
        paymentMethodRadios: '[name="payment[method]"]'
    },

    initialize: function () {
        this.updatePaymentModelFromView();

        /*
        Setup listeners
         */
        this.listenTo(this.model, 'change:paymentMethod', this.onPaymentMethodChange);
    },

    updatePaymentModelFromView: function () {
        this.model.set({
            paymentMethod: this.$(this.selectors.paymentMethodRadios).filter(':checked').val()
        });
    },

    onPaymentMethodChange: function () {
        this.showCurrentPaymentMethod();
    },

    showCurrentPaymentMethod: function () {
        this.$(this.selectors.content).addClass('is-hidden');
        this.$(this.selectors.paymentMethodRadios + '[value="' + this.model.get('paymentMethod') + '"]')
            .prop('checked', true)
            .closest('.checkout-payment-box')
            .find('.checkout-frame')
            .removeClass('is-hidden');
        updateState();
    },

    onUserPaymentMethodChange: function () {
        this.updatePaymentModelFromView();
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentView.js
 **/